var map = {
	"./arrow-right.svg": "6929",
	"./icon-dhls.svg": "be7c",
	"./icon-jbmx.svg": "e231",
	"./icon-notice.svg": "f06d",
	"./icon-rwjl.svg": "938a",
	"./icon-wdsy.svg": "caf0",
	"./icon-wdxyz.svg": "b7bc",
	"./icon-wdyq.svg": "ef90",
	"./icon-zhsz.svg": "2b9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";